export default "__VITE_ASSET__CUC96XDm__"